import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Collections, Parts, Types, Elements, Objects} from "components";

import {Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";


/**
 *  @property {Transactions_Collections_Object} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class TransferObject extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_TRANSFER';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_TRANSFER' : 'PUT_TRANSFER';
		this.delete = 'DELETE_TRANSFER';

		this.afterEventSave = this.setNewObject('event');
		this.afterDealerSave = this.setNewObject('dealer');

		this.state.toggleDealerModal = Math.random();
		this.state.link_triggered = false;
	}


	componentDidMount() {
		super.componentDidMount();
		if(this.props.transaction_entries) {
			let transaction_entriess = [];
			for (let entry of this.props.transaction_entries) {
				transaction_entriess.push({
					pawn_redemption: false,
					pawn_redemption_error: "",
					product: entry.pkey,
					product_binary_id: entry.binary_id,
					products: entry
				});
			}
			this.setState({transaction_entriess});
		}

		if(this.props.order_id) {
			this.setState({foreign_order_id: this.props.order_id});
		}
	}
	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.transaction || (object.binary_id + '-' + object.pkey));
		}

		//toggle P12 form
		if(prevProps.toggleForm !== this.props.toggleForm){
			this.setState({formP12: true});
		}

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
			//Then check related props
			//If "Internal" select was updated, update corresponding Dealer Information
			if (object.locations_related_by_internal && object.internal !== prevState.internal) {
				this.setState({
					'dealer_name_company': object.internal ? object.locations_related_by_internal.name_display || object.locations_related_by_internal.name : '',
					'dealer_ffl': object.internal ? object.locations_related_by_internal.ffl : ''
				});
			}
			//If "Dealer" select was updated, update corresponding Dealer Information
			if (object.dealers && object.dealer !== prevState.dealer) {
				this.setState({
					'dealer_name_company': object.dealer ? object.dealers.name_display || object.dealers.name_trade || object.dealers.name_company : '',
					'dealer_ffl': object.dealer ? object.dealers.ffl : ''
				});
			}
		}
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (data.internal != null) {
			this.setState({'acquired_from': 'internal'});
		} else if (data.dealer != null) {
			this.setState({'acquired_from': 'dealer'});
		} else if (data.customer != null) {
			this.setState({'acquired_from': 'customer'});
		}

		if (data.pawn_inventory || data.pawn_ticket) {
			this.setState({'is_pawn': true});
		}

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.transaction || (data.binary_id + '-' + data.pkey));
		}
	};

	deleteAllProducts = () => {
		if(this.state._id === '') {
			this.setState({transaction_entriess: []})
		}
		else {
			confirmAlert({
				title: "Confirm Delete All",
				message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to delete all items from this transfer?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							this.model = new API.BuildClass(Types.Transactions_Entries._name, 'DELETE');
							this.model.parent = this.state.pkey;
							await this.model.submit(null, 'DELETE_ALL').then(() => {
								window.location.reload();
								// this.setState({transaction_entriess: []});
							});
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		}
	};

	ignoreWarning = (warningName) => {
		this.setState({[warningName]: true})
	}

	handleGoToDealer = async () => {
		localStorage.setItem('dealer_email', this.state.dealers.email);
		this.setState({toggleDealerModal: Math.random(), link_triggered: true});

		let dealerEmailLog = new API.BuildClass(Types.Dealers_Missing_Email_Logs._name, API.RequestType.CREATE);
		dealerEmailLog.object.ffl_type = this.state.dealers.ffl_type;
		dealerEmailLog.object.dealer = this.state.dealer;
		dealerEmailLog.object.dealer_binary_id = this.state.dealer_binary_id;
		dealerEmailLog.parent = this.state.dealer_binary_id + '-' + this.state.dealer;
		let result = await dealerEmailLog.submit(null, API.RequestType.CREATE, true);

	}


	async handleSubmit(e, suppressToast = false, suppressProcess = false) {
		if (this.state.dealers && !this.state.dealers.email && !this.props.id) {
			confirmAlert({
				title: "Missing Dealer Email",
				message: "Are you sure you want to save this without a dealer email? We can send them a list of firearms if you add their email.",
				buttons: [
					{
						label: 'Add Email',
						onClick: () => {
							this.handleGoToDealer();
						},
						className: 'btn btn-primary'
					},
					{
						label: 'Save Anyway',
						onClick: () => {
							super.handleSubmit(e, suppressToast, suppressProcess);
						},
						className: 'btn btn-warning',
					},

				]
			});
			return;
		}
		await super.handleSubmit(e, suppressToast, suppressProcess);
	}

	form = () => {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					{object.dealers && !object.dealers.email && !this.props.id &&
						<a onClick={() => this.handleGoToDealer()} style={{ cursor: 'pointer' }}>
							<WarningAlert
								hideButton={true}
								warningName={'Missing Dealer Email'}
								warningMessage={"Dealer email is missing. We can send them a list of firearms if you fill out their email. [Click Me To Fix]"}
							/>
						</a>
						}
					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>

							{/*#region Transfer to FFL Section*/}
							<h4 className="section-title">Transfer to FFL</h4>
							{(!object.pkey || object.dealer) &&
								<Parts.TransactionDealer
									locations={this.props.locations}
									states={this.props.states}
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									history={this.props.history}
									onTextUpdate={this.handleTextFieldPropertyUpdate}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									afterDealerSave={this.afterDealerSave}
									disableFields={true}
									toggleDealerModal={this.state.toggleDealerModal}
									dealerId={this.state.dealer}
									dealerBinaryId={this.state.dealer_binary_id}
									dealerObject={this.state.dealers}
									linkTriggered={this.state.link_triggered}

								/>}

							{(object.pkey && object.internal) &&
								<div className={'form-group'}>
									<div className="row">
										<div className="col-4">
											<span className="input-label">Transferred for Manufacturing</span>
										</div>
										<div className="col-8">
											<Framework.Elements.Select
												shouldLoad={this.state.loaded}
												update={this.handleSelectPropertyUpdate}
												property={properties.internal}
												objects={this.props.locations}
												value={object.internal}
												error={object.internal_error}
												object={object.locations_related_by_internal}
												text={'name_display|name'}
												nullable={false}
												filter={this.filterLocationOptions}
											/>
										</div>
									</div>
								</div>}
							{/*#endregion*/}

							{/*#region Details Section*/}
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							<Parts.TransactionDetails
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterEventSave={this.afterEventSave}
							/>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Items Section*/}
							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary"
										        data-id={'quick-transfer-products'}>
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"In Stock Products"}
										object={Collections.ProductsExisting}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
										status={"GET_IN_STOCK"}
										objectProps={{scannedCode: this.props.scannedCode}}
									/>

									{(this.props.userAccess === 0 || 10) && (object.transaction_entriess.length >= 10) &&
										<Button onClick={this.deleteAllProducts} size={"sm"} color="danger" style={{marginLeft: "5px"}}>
											<i className={"fa fa-trash-o"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Delete All</span>
										</Button>
									}
								</div>
							</h4>

							{object.transaction_entriess && object.transaction_entriess.map(
								(entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
									/>
							)}

							<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}

						<UniversalModalOverride
							locations={this.props.locations}
							states={this.props.states}
							title="New York P12 Form"
							object={Objects.FormP12}
							history={this.props.history}
							toggle={this.state['formP12']}
							reportClose={this.reportClose('formP12')}
							afterSave={() => this.props.generatedForm()}
							url="dispositions"
							size="xl"
							objectProps ={{
								products: this.state.transaction_entriess,
								transaction_date: this.state.date,
								collection: this.props.id,
								transfer_state: this.state,
							}}
							submitLabel={"Generate P12 Form"}
						/>

					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}
